import { render, staticRenderFns } from "./AffinityMechanics.vue?vue&type=template&id=846a633a"
import script from "./AffinityMechanics.vue?vue&type=script&lang=js"
export * from "./AffinityMechanics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports